const initialState = {

  currentRoute: {
    path: "/"
  },

  progress: {
    progress: 0
  },

  auth: {
    isAuthenticated: false,
    isLoggingIn: false,
    isLoggingOut: false,
    isSubmitting: false,
    isConfirming: false,
    requiresPassword: false,
    passToken: undefined,
    confirmed: false,
    isValidating: false,
    tokenInvalid: false,
    failedLogin: false,
    resetSuccessful: false,
    resetSent: false,
    current_user: {
      data: {},
      errors: []
    },
    errors: []
  },

  businesses: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    setting_status: false,
    set_status: false,
    must_redirect: false,
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    business: {},
    items: [],
    totals: {},
    select_items: []
  },

  busers: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    setting_status: false,
    set_status: false,
    must_redirect: false,
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    buser: {},
    items: [],
    totals: {},
  },

  competencies: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    must_redirect: false,
    errors: [],
    items: [],
    competency: {},
  },

  coupons: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    setting_status: false,
    set_status: false,
    must_redirect: false,
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    coupon: {},
    items: [],
    totals: {},
    select_items: []
  },

  graphs: {
    fetching: false,
    fetched: false,
    data: {
      tests_served: [],
      tests_per_skill: [],
      payment_types: [],
      income_per_skill: [],
      creators_performance: [],
      questions_status: [],
      template_usage: [],
      question_levels: [],
      test_levels: [],
      own_question_levels: [],
    },
    from: null,
    to: null,
    time_start: null,
    timestamp: null,
    total_users: 0,
    total_tests: 0,
    invites: 0,
    consumed: 0,
    total_vouchers: 0,
    errors: []
  },

  preferences: {
    fetching: false,
    fetched: false,
    mustRedirect: false,
    errors: [],
    preferences: {
    },
    levels: []
  },

  skills: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    must_redirect: false,
    errors: [],
    items: [],
    skill: {
    },
  },

  templates: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    fetching_xlsx: false,
    setting_status: false,
    set_status: false,
    errors: [],
    items: [],
    totals: {
    },
    template: {
      versions: [],
      competencies: []
    },
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1,
      total: 0
    },
    select_items: []
  },

  tests: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    fetching_xlsx: false,
    skip: 0,
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    test: {
      questions: [],
      competency_levels: {}
    },
    items: [],
    totals: {},
  },

  users: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    setting_status: false,
    fetching_xlsx: false,
    set_status: false,
    must_redirect: false,
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    user: {},
    items: [],
    totals: {},
    select_items: [],
    ages: {},
    genders: {},
    industries: {},
    educations: {},
  },

  vouchers: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    setting_status: false,
    set_status: false,
    must_redirect: false,
    serial: 0,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    warnings: [],
    upload_success: false,
    voucher: {},
    items: [],
    campaigns: [],
    totals: {},
    select_items: [],
    autofill: []
  },

  viewport: {
    collapseSidebar: false,
    showMobileMenu: false
  }

}

export default initialState



// WEBPACK FOOTER //
// ./src/js/store/initialState.js